import cx from 'classnames';

import {Icon} from '../Icon';

type Props = {
    header?: string | React.ReactNode;
    message: string | React.ReactNode;
    controlled?: boolean;
    color?: 'primary' | 'light';
    onClose?: () => void;
};

export const TooltipElement = ({header, message, controlled, color = 'primary', onClose}: Props) => (
    <div className={cx('vs-tooltip-content tw-text-left', color)}>
        <div className='tw-flex tw-items-center'>
            {header &&
                <div className='tw-font-bold tw-leading-loose'>{header}</div>}
            <div className='tw-flex-1' />
            {controlled &&
                <div
                    className={cx('tw-cursor-pointer tw-p-1 tw-ml-3 tw--right-1 tw-relative', {
                        'tw-bg-light tw-bg-opacity-10 hover:tw-bg-opacity-20': color === 'primary',
                        'tw-bg-dark tw-bg-opacity-5 hover:tw-bg-opacity-10': color === 'light'
                    })}
                    onClick={() => onClose()}
                >
                    <Icon
                        name='close'
                        color={color === 'primary' ? 'alternative' : 'dark'}
                    />
                </div>}
        </div>
        <div className='tw-break-words'>
            {message}
        </div>
    </div>
);
